// extracted by mini-css-extract-plugin
module.exports = {"sa5ik9c":"sa5ik9c","title":"title","summary":"summary","mark":"mark","time":"time","with-hot":"with-hot","with-delete":"with-delete","delete":"delete","hli44s9":"hli44s9"};